module.exports = __webpack_public_path__ + "static/media/para-icon.084ed041.png";